export type { StorySlide, StoryItem } from "../types";
import type { StorySlide, StoryItem } from "../types";

export type Category =
  | "Menyerang Lawan"
  | "Argumen Lemah"
  | "Manipulasi Emosi & Sosial"
  | "Logika Rusak"
  | "Manipulasi Statistik"
  | "Jebakan Strategi"
  | "Otak yang Menipu Diri"
  | "Jebakan Bahasa"
  | "Jebakan Digital";

export interface StoryTemplate {
  hook: { title: string; body: string };
  convo: { claim: string; response: string };
  reveal: { body: string };
  insight: { title: string; body: string };
  engagement: { title: string; body: string };
}

export function createStory(name: string, emoji: string, t: StoryTemplate): StorySlide[] {
  return [
    { type: "hook", title: t.hook.title, body: t.hook.body },
    { type: "convo", claim: t.convo.claim, response: t.convo.response },
    { type: "reveal", title: `Ini namanya ${name} ${emoji}`, body: t.reveal.body },
    { type: "insight", title: t.insight.title, body: t.insight.body },
    { type: "engagement", title: t.engagement.title, body: t.engagement.body },
  ];
}

export interface Fallacy extends StoryItem {
  category: Category;
}
